import { useState, useEffect } from "react";

/* useMediaQuery — subscribe to a CSS media query and re-render on change.
   Used to mount ONLY the active stage-table layout (desktop table vs mobile
   cards) instead of both, so a stage switch doesn't also mount ~100 invisible
   rows (perf, 17-Jul). Defaults to true when matchMedia is unavailable — the
   desktop table is the primary surface and the app is desktop-first. */
export function useMediaQuery(query) {
  const read = () =>
    typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia(query).matches
      : true;
  const [matches, setMatches] = useState(read);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange(); // sync in case it changed between first render and effect
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}
